/**
 * Provides a promise api to setTimeout. The wait utility is a factory
 * function which allows the wait methods to be invoked lazily.
 *
 * @params {Object} options
 * @params {number} options.for the default amount of time to wait
 */
var wait = function wait() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return {
    start: function start(delay) {
      var _this = this;

      if (this.current) return this.current;
      this.current = new Promise(function (resolve) {
        _this.timeoutId = setTimeout(resolve, delay || options.for);
        _this.resolve = resolve;
      });
      return this.current;
    },
    cancel: function cancel() {
      this.end();
    },
    end: function end() {
      clearTimeout(this.timeoutId);
      this.resolve();
      this.current = null;
      this.timeoutId = null;
    }
  };
};

export default wait;